<template>
  <div class="front-page" style="">
    <a-card class="front-content">
      <a-result
          v-if="visit.status === '09'"
          status="error"
          :title="$t('prohibitVisit')"
          sub-title="Your account has been disabled. If you have questions, please contact the Translational Medicine Center"
      >
        <div class="desc">
          <p style="font-size: 16px">
            <strong>{{
                $t("prohibitTime") + formatDate(visit.starttime) + " - " + formatDate(visit.endtime)
              }}</strong>
          </p>
          <p style="font-size: 16px">
            <strong>The disabling time is: {{
                formatDate(visit.starttime) + " - " + formatDate(visit.endtime)
              }}</strong>
          </p>
        </div>
      </a-result>
      <a-result
          v-else-if="visit.status === '00'"
          :title="$t('waitPass')"
          sub-title="You have submitted an access request, please wait patiently for the review.If you have questions, please contact the Translational Medicine Center"
      >
        <template #icon>
          <smile-twoTone/>
        </template>
      </a-result>
      <a-result status="500"
                v-else
                :title="$t('noPermission')"
                sub-title="You do not have permission to access this site.If you have questions, please contact the Translational Medicine Center">
        <template #extra>
          <div>
            <a-input-group compact>
              <a-input :placeholder="$t('pleaseEnterPhone')" style="width: 30%" v-model:value="phone"></a-input>
              <a-button type="primary" @click="submitVisit" style="width: 20%;margin: 0 0">{{
                  $t("submitVisit")
                }}
              </a-button>
            </a-input-group>
          </div>
        </template>
      </a-result>
    </a-card>

    <v-loading :show="loading"></v-loading>
  </div>
</template>

<script>

import VLoading from "@/components/public/v-loading";
import util from "@/util/util";
import {SmileTwoTone} from '@ant-design/icons-vue';

export default {
  name: "beforeHome",
  components: {
    VLoading,
    SmileTwoTone
  },
  data: function () {
    return {
      loading: false,
      visit: {},
      phone: ""
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    formatDate(date) {
      return util.dateFormat(date, "YYYY-MM-DD");
    },
    initPage() {
      var that = this;
      util.$post("/home/beforeLogin/init", {}, function (retMap) {
        that.visit = retMap.visit;
        if (that.visit.status === "01") {
          that.$router.push("/home");
        }
      }, this.showLoading, this.hideLoading);
    },
    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
    submitVisit() {
      if (util.isNull(this.phone)) {
        util.notificationError(this.$t("pleaseEnterPhone"))
        return;
      }
      var that = this;
      util.$confirm({
        title: this.$t("confirmVisit"),
        cancelText: this.$t("cancel"),
        okText: this.$t("confirm"),
        onOk: () => {
          util.$post("/home/beforeLogin/submitVisit", {phone: this.phone}, function () {
            util.submitSuccess();
            that.initPage();
          }, that.showLoading, that.hideLoading)
        }
      })
    }
  }
}
</script>

<style scoped>
.front-page {
  width: 100%;
  height: 100vh;
  text-align: center;
  background-color: #e8e8e8;
}

.front-content {
  width: 1000px;
  min-height: 500px;
  display: inline-block;
  margin-top: 5vh;
}
</style>